<script lang="ts">
  import { onMount } from 'svelte'
  import SettingsSidebar from './SettingsSidebar.svelte'
  import GeneralSettings from './GeneralSettings.svelte'
  import SubscriptionSettings from './SubscriptionSettings.svelte'
  import ApiSettings from './ApiSettings.svelte'
  import AISettings from './AISettings.svelte'
  import AppearanceSettings from './AppearanceSettings.svelte'
  import ShortcutsSettings from './ShortcutsSettings.svelte'
  
  interface Props {
    onClose?: () => void
  }
  
  let { onClose }: Props = $props()
  
  // Current active tab
  let activeTab = $state('general')
  
  function handleTabChange(tab: string) {
    activeTab = tab
  }
  
  function handleClose() {
    onClose?.()
  }
  
  // Save settings on unmount
  onMount(() => {
    return () => {
      // Auto-save settings when leaving the page
    }
  })
</script>

<div class="settings-container">
  <div class="settings-header">
    <h1 class="settings-title">설정</h1>
    <button class="close-btn" onclick={handleClose} aria-label="닫기">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>
  </div>
  
  <div class="settings-content">
    <SettingsSidebar {activeTab} onTabChange={handleTabChange} />
    
    <div class="settings-panel">
      {#if activeTab === 'general'}
        <GeneralSettings />
      {:else if activeTab === 'subscription'}
        <SubscriptionSettings />
      {:else if activeTab === 'api'}
        <ApiSettings />
      {:else if activeTab === 'ai'}
        <AISettings />
      {:else if activeTab === 'appearance'}
        <AppearanceSettings />
      {:else if activeTab === 'shortcuts'}
        <ShortcutsSettings />
      {/if}
    </div>
  </div>
</div>

<style>
  .settings-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bg-secondary);
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }
  
  .settings-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 52px;
    border-bottom: 1px solid var(--border-primary);
    background: var(--bg-primary);
    -webkit-app-region: drag;
  }
  
  .settings-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
    letter-spacing: -0.3px;
  }
  
  .close-btn {
    position: absolute;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: transparent;
    border: none;
    border-radius: 6px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.15s;
    -webkit-app-region: no-drag;
  }
  
  .close-btn:hover {
    background: var(--bg-tertiary);
    color: var(--text-primary);
  }
  
  .settings-content {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
  
  .settings-panel {
    flex: 1;
    overflow-y: auto;
    background: var(--bg-secondary);
  }
  
  /* Dark mode handled by CSS variables */
</style>